import NEW_BOOKING_STEPS from 'constants/newBookingSteps';

const VET_SUPPLY = Object.freeze({
    productList: NEW_BOOKING_STEPS.productList,
    confirmation: NEW_BOOKING_STEPS.confirmation
});

export default VET_SUPPLY;
